import {ContentBlocks_ImageVideo} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/content_blocks.types';
import {
  ContentBlockImageTile,
  ContentBlockVideoAutoPlay,
  FONT_SIZES,
  FONT_WEIGHTS,
  Text,
  tabletAndUpLinaria,
} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';
import {
  transformImage,
  transformVideo,
} from '../../../ContentBlocks/transforms';

export function hexToRgb(hex: string) {
  // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
  const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
  hex = hex.replace(shorthandRegex, function (_, r, g, b) {
    return r + r + g + g + b + b;
  });

  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)!;
  return {
    r: parseInt(result[1]!, 16),
    g: parseInt(result[2]!, 16),
    b: parseInt(result[3]!, 16),
  };
}

export const ImageOrVideoTile = (props: {
  media: ContentBlocks_ImageVideo;
  videoControlsPosition: 'top' | 'left-top';
}) => {
  if (props.media.imageOrVideo?.$case === 'image') {
    return (
      <ContentBlockImageTile
        image={{
          ...transformImage(props.media.imageOrVideo.image),
          aspectRatio: '1:1',
        }}
      />
    );
  }
  if (props.media.imageOrVideo?.$case === 'video') {
    return (
      <ContentBlockVideoAutoPlay
        video={{
          ...transformVideo(props.media.imageOrVideo.video),
          aspectRatio: '1:1',
        }}
        intersectionThreshold={0.4}
        customControlsPosition={props.videoControlsPosition}
        customControlsAlignment="vertical"
      />
    );
  }

  return null;
};

export const VideoBlur = styled.div`
  position: absolute;
  inset: 0;
  backdrop-filter: blur(8px);
`;

export const HeroElementBodyText = styled(Text)`
  opacity: 0.6;
  line-height: 1.125rem; /* 150% */
  font-size: ${FONT_SIZES.px12};
  ${tabletAndUpLinaria(`
    line-height: 1.25rem;
    opacity: 1;
    font-size: ${FONT_SIZES.px14};
    text-align: left;
  `)};
`;

export const HeroElementHeadline = styled(Text)`
  font-size: ${FONT_SIZES.px14};
  font-weight: ${FONT_WEIGHTS.heavy};
  line-height: 1.25rem;
  text-transform: uppercase;

  ${tabletAndUpLinaria(`
      font-size: ${FONT_SIZES.px16};
      font-weight: ${FONT_WEIGHTS.mediumHeavy};
      line-height: 1.5rem;
      text-align: left;
    `)};
`;
